export default __webpack_public_path__ + "static/media/ornek_toplu_ise_giris.143cfdf4.xlsx";